(function () {

seedWebApp.controller('EmailModalCtrl', EmailModal);
    function EmailModal(item, translation, isEdit, $scope, $uibModal, $uibModalInstance, $document, ToastService, EmailService, StoreService, UtilsService) {
        var ctrl = this;

        console.log('EmailModalCtrl');
        if (!item.EmailTrigger) {
            item.EmailTrigger = 'ByStatus';
        }

        ctrl.item = item;
        ctrl.translation = translation;
        ctrl.isEdit = isEdit;

        loadStatusTypes();
        ctrl.sitPortals = loadSitPortals();
        loadDocTypeList();
        loadDocTypesFromEmail();


        ctrl.addEmail = function () {
            waitToast('Saving...');
            ctrl.item.DocTypeList = formatListDocOptions(ctrl.item.DocTypeList, false);
            EmailService.saveEmail(ctrl.item).then(function (response) {
                successToast('O Email foi Adicionado.');
                $uibModalInstance.close();
            })
            .catch(function (error) {
                $uibModalInstance.close();
                errorToast(error.data.ExceptionMessage);
            });
        }

        ctrl.updateEmail = function () {
            waitToast('Saving...');
            ctrl.item.DocTypeList = formatListDocOptions(ctrl.item.DocTypeList, false);
            EmailService.updateEmail(ctrl.item).then(function (response) {
                successToast('O Email foi Atualizado.');
                $uibModalInstance.close();
            })
            .catch(function (error) {
                //$uibModalInstance.close();
                errorToast(error.data.ExceptionMessage);
            });
        }

        ctrl.deleteEmail = function () {
            modalDeleteResult(openModalDelete());
        }

        ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        ctrl.addItemToList = function () {
            ctrl.listDocOptions.push({ Key: null });
        }

        ctrl.removeItemToList = function (index) {
            ctrl.listDocOptions.splice(index, 1);
        }

        function waitToast(msg) {
            ToastService.clear();
            ToastService.createToast(ctrl.translation.Wait, msg, 8000, 'wait');
        }

        function successToast(msg) {
            ToastService.clear();
            ToastService.createToast(ctrl.translation.Success, msg, 8000, 'success');
        }

        function errorToast(error) {
            ToastService.clear();
            ToastService.createToast(ctrl.translation.Error, error, 5000, 'error');
        }

        function loadDocTypeList() {
            EmailService.getDocTypeList().then(function (response) {
                formatDocTypes(response.data);
            });
        }

        function formatDocTypes(docs) {
            ctrl.docTypes = docs.map(function (doc) {
                return { Key: doc.DocTypeID, Value: doc.DocTypeName };
            });
        }

        function loadDocTypesFromEmail() {
            if (ctrl.isEdit) {
                EmailService.getDocTypeFromEmail(ctrl.item.EmailID).then(function (response) {
                    if (response.data.length)
                        ctrl.listDocOptions = formatListDocOptions(response.data, true);
                    else
                        ctrl.listDocOptions = [{ Key: null }];
                });
            }
            else {
                ctrl.listDocOptions = [{ Key: null }];
            }
        }

        function formatListDocOptions(list, toKey) {
            if (toKey) {
                return list.map(function (item) {
                    item.Key = item.DocTypeID;
                    delete item.DocTypeID;
                    return item;
                });
            }
            else {
                return list.map(function (item) {
                    item.DocTypeID = item.Key;
                    delete item.Key;
                    return item;
                });
            }
        }

        function openModalDelete() {
            return $uibModal.open({
                templateUrl: './SPA/Shared/delete-modal.html',
                controller: 'DeleteModalCtrl as ctrl',
                size: 'md',
                resolve: {
                    translation: function () {
                        return ctrl.translation;
                    },
                }
            });
        }

        function modalDeleteResult(modalInstance) {
            modalInstance.result.then(function (response) {
                if (response == 'true') confirmDeleteEmail();
            });
        }

        function confirmDeleteEmail() {
            EmailService.deleteEmail(ctrl.item.EmailID).then(function (response) {
                successToast('O Email foi Removido.');
                $uibModalInstance.close();
            })
            .catch(function (error) {
                errorToast('Erro ao Remover o Email.');
            });
        }

        $scope.$watch(function () { return ctrl.listDocOptions }, function () {
            ctrl.item.DocTypeList = ctrl.listDocOptions;
        });


        ctrl.sendTestEmail = function () {
            ctrl.item.DocTypeList = formatListDocOptions(ctrl.item.DocTypeList, false);
            EmailService.sendTestEmail(ctrl.item).then(function (response) {
                successToast('O Email foi Enviado');
                //$uibModalInstance.close();
            })
                .catch(function (error) {
                    //$uibModalInstance.close();
                    errorToast(error.data.ExceptionMessage);
                });
        }


        function loadStatusTypes() {
            StoreService.getStatusList('').then(
                function (result)
                {
                    ctrl.statusTypes = result.data.map(function (item) {
                        return {
                            Group: item.Group,
                            Key: item.Key,
                            Value: ctrl.translation['Status_' + item.Value]
                        }
                    });
                }
            );
        }

        function loadSitPortals() {
            var statusTypes = [];
            statusTypes.push({ Key: null, Value: '(Any)' }); //APENAS PARA ADMIN
            statusTypes.push({ Key: '5', Value: 'Accepted' }); //APENAS PARA ADMIN
            statusTypes.push({ Key: '2', Value: 'Rejected' }); //APENAS PARA ADMIN
            statusTypes.push({ Key: '4', Value: 'Waiting' }); //APENAS PARA ADMIN
            return statusTypes;
        }

        ctrl.availableFields = function () {
            var fields = [];
            fields.push({ name: '##OrderID', description: 'Order ID' });
            //fields.push({ name: '##BratID', description: 'Order ID' });
            fields.push({ name: '##ContactID', description: 'Customer ID' });
            fields.push({ name: '##ContactName', description: 'Customer Name' });
            fields.push({ name: '##StatusID', description: 'Status' });
            fields.push({ name: '##ProcExpID', description: 'Invoice Number' });
            fields.push({ name: '##ContractNumber', description: 'PO# Number' });
            fields.push({ name: '##BillOfLadding', description: 'BL# Number' });
            fields.push({ name: '##AcceptComments', description: 'Accept Comments' });
            fields.push({ name: '##RejectComments', description: 'Reject Comments' });
            fields.push({ name: '##VesselName', description: 'Vessel Name' });

            fields.push({ name: '##BookingID', description: '#Booking' });
            fields.push({ name: '##InvoiceDate', description: 'Data Faturamento' });

            fields.push({ name: '##UserID', description: 'User id that triggered event' });

            fields.push({ name: '##ProcExpLink', description: 'Link to order' });
            fields.push({ name: '##ShippingDocsLink', description: 'Link to shipping documents' });

            fields.push({ name: '##ShippingDate', description: 'Ship Date' });
            fields.push({ name: '##DeparturePointID', description: 'Pto Saida Embarque' });

            return fields;
        }
        ctrl.fields = ctrl.availableFields();


        //ctrl.drop = function (event) {
        //    //var buttonText = $scope.buttonList[index];
        //    //$scope.textareaValue += buttonText + ' ';

        //    console.log('drop', event);
        //    var textarea = $document[0].activeElement;
        //    if (textarea.nodeName === 'TEXTAREA') {
        //        var data = event.dataTransfer.getData("Text");
        //        textarea.value += data + ' ';
        //    }            
        //};

        //ctrl.selectArea = function (ev) {
        //    ctrl.selectedArea = $document[0].activeElement;
        //    console.log('area selected ', ctrl.selectedArea);
        //}

        //ctrl.insertText = function (text) {
        //    console.log('insertText ' + text);

        //    // Get the currently selected text area element
        //    var textarea = $document[0].activeElement;

        //    if (ctrl.selectedArea) {
        //        textarea = ctrl.selectedArea;
        //    }

        //    // Check if the selected element is a text area
        //    if (textarea.nodeName === 'TEXTAREA') {
        //        // Get the current selection range
        //        var selectionStart = textarea.selectionStart;
        //        var selectionEnd = textarea.selectionEnd;

        //        // Insert the text at the current selection position
        //        var value = textarea.value;
        //        var newValue = value.substring(0, selectionStart) + text + value.substring(selectionEnd);

        //        // Set the updated value back to the text area
        //        textarea.value = newValue;

        //        // Set the selection range to the end of the inserted text
        //        textarea.setSelectionRange(selectionStart + text.length, selectionStart + text.length);

        //        // Trigger an input event to ensure any AngularJS bindings are updated
        //        var event = new Event('input');
        //        textarea.dispatchEvent(event);
        //    }
        //};


        ctrl.getAvailableFields = function () {
            var msg = 'Available fields, prefixed with ## ';
            msg += '\n';
            msg += '\n##OrderID           Order ID';
            //msg += '\n##BratID            Brat ID';
            msg += '\n##ContactID         Customer ID';
            msg += '\n##ContactName       Customer Name';
            msg += '\n##StatusID          Status';
            msg += '\n##ProcExpID         Invoice Number';
            msg += '\n##ContractNumber    PO# Number';
            msg += '\n##BillOfLadding     BL# Number';
            msg += '\n##AcceptComments    Accept Comments';
            msg += '\n##RejectComments    Reject Comments';
            msg += '\n##VesselName        Vessel Name';
            msg += '\n##UserID            User id that triggered event';
            msg += '\n##ProcExpLink       Link to order';

            return msg;
        };

        ctrl.copyField = function (field)
        {
            UtilsService.copyToClipboard(field.name);
            successToast(field.name + ' copiado para o clipboard');
        };

        //ctrl.toggle = function (field) {
        //    if (!field.expanded) {
        //        field.short = field.description;
        //    }            

        //    field.expanded = !field.expanded;            
        //    if (field.expanded)
        //        field.description = 'ksjkh kjhda sdkjashd aksjjdjh aksjd akjsdh askjhd akjhd akjhd akjhds akjsd ajkhsd akjsh dakjshd akjhs djas dkjahs dkjah sdkjahs dajkshd ajhd kaj dakjshd akjsdh'
        //    else
        //        field.description = field.short;
        //};

        ctrl.handleTab = function (e) {
            //console.log('handleTab',e);
            if (e.key == 'Tab') {               
                e.preventDefault();

                var start = e.target.selectionStart;
                var end = e.target.selectionEnd;

                //vm.text = vm.text.substring(0, start) + '\t' + vm.text.substring(end);
                e.target.value = e.target.value.substring(0, start) + "\t" + e.target.value.substring(end);
                e.target.selectionStart = e.target.selectionEnd = start + 1;
            }
        };
    }

  
})();
